export enum TagTypes {
  Registration = "Registration",
  RegistrationTransition = "RegistrationTransition",
}
